import classNames from "classnames/bind";
import React from "react";
import { IconLoading } from "../Icon";
import { Skeleton } from "../Skeleton";
import styles from "./Pill.module.scss";
import { PillProps } from "./types";

const cx = classNames.bind(styles);

// Dot should not be on default variant unless explicitly set
export const shouldDisplayPillDot = (
  variant: PillProps["variant"] = "default",
  hasDot?: boolean
): boolean => {
  if (typeof hasDot === "undefined" && variant === "default") {
    return false;
  } else if (typeof hasDot === "undefined") {
    return false;
  } else {
    return hasDot;
  }
};

const Pill = ({
  variant = "default",
  children,
  isBordered,
  hasBackgroundColor = true,
  hasDot,
  iconLeft,
  iconRight,
  isLoading,
  isBusy,
  isDisabled,
}: PillProps) => {
  const pillBody = (
    <>
      {iconLeft ? (
        <Skeleton
          isLoading={isLoading}
          isBusy={isBusy}
        >
          <div className={cx("icon-left")}>{iconLeft}</div>
        </Skeleton>
      ) : shouldDisplayPillDot(variant, hasDot) ? (
        <Skeleton
          isLoading={isLoading}
          isBusy={isBusy}
        >
          <div
            className={cx("pillIndicator", isDisabled ? "disabled" : variant)}
            role="presentation"
            aria-label="Dot indicator"
          />
        </Skeleton>
      ) : (
        <div className={cx("spacer")} />
      )}
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
        style={{
          borderRadius: 4,
          height: 11,
        }}
      >
        {children}
      </Skeleton>
      {iconRight ? (
        <Skeleton
          isLoading={isLoading}
          isBusy={isBusy}
        >
          <div className={cx("icon-right")}>{iconRight}</div>
        </Skeleton>
      ) : (
        <div className={cx("spacer")} />
      )}
    </>
  );

  return (
    <div
      className={cx(
        "container",
        isBusy || isLoading || isDisabled ? "default" : variant,
        { isDisabled },
        { isBordered },
        { whiteBackground: !hasBackgroundColor }
      )}
      role="note"
    >
      {isBusy && (
        <div className={cx("icon-left")}>
          <IconLoading size={12} />
        </div>
      )}
      {pillBody}
    </div>
  );
};

export default Pill;
